import React from "react";
import { FileDropDown } from "../FileDropDown";
import { DropDownSheet } from "../co-dropdown-panel/drop-down-sheet/DropDownSheet";
import { ChoiceGroup } from "@fluentui/react";

import ImportAmountAreaSelectionField from "./import-amount/ImportAmountAreaSelectionField";
import { InputAreaSelectionEnum } from "../../../utils/constants/InputAreaSelectionEnum";
import { isNullOrEmptyString } from "@progress/kendo-data-query/dist/npm/utils";
import useExcelAmountSourcePanel, { ExcelComponentProps } from "./ExcelAmountSourcePanelHook";

export const ExcelAmountSourcePanel = (props: ExcelComponentProps) => {
  const {
    objectSource,
    onFileClick,
    selectSheetComboBox,
    initAreas,
    sheetsAreaChartMap,
    selectedAreaOption,
    areaOptions,
    changeAreaSelection,
    selectAreaComboBox,
    selectAmountFromExcelCell,
    isFileExcelExisting,
    fileExcelName,
    updateFileExcelName,
    isComponentInstance,
    isLocked,
    setIsOldValueForAreaToHide,
    isOldValueForAreaToHide,
    hasSheetToBeSelected,
    setHasSheetToBeSelected,
    isLoadingDataExcel,
    setIsLoadingDataExcel,
  } = useExcelAmountSourcePanel(props);

  return (
    <div>
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <FileDropDown
          form={objectSource.form}
          onFileClick={onFileClick}
          objectSource={objectSource.objectSource}
          fileExcelName={fileExcelName}
          updateFileExcelName={updateFileExcelName}
          isComponentInstance={isComponentInstance}
          isLocked={isLocked}
        />
      </div>

      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <DropDownSheet
          isEdit={props.isEdit}
          sheet={objectSource.sheet}
          form={objectSource.form}
          dbApplication={objectSource.dbApplication}
          selectSheetComboBox={selectSheetComboBox}
          initAreas={initAreas}
          type={"AMOUNT"}
          objectSource={objectSource.objectSource}
          sheetsAreaChartMap={sheetsAreaChartMap}
          isFileExcelExisting={isFileExcelExisting}
          isComponentInstance={isComponentInstance}
          isLocked={isLocked}
          originalSheetArea={props.originalSheetArea}
          setOriginalSheetArea={props.setOriginalSheetArea}
          setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
          setIsOldValueForAreaToHide={setIsOldValueForAreaToHide}
          setHasSheetToBeSelected={setHasSheetToBeSelected}
          isLoadingDataExcel={isLoadingDataExcel}
          setIsLoadingDataExcel={setIsLoadingDataExcel}
          setIsLoadingSheetAndArea={props.setIsLoadingSheetAndArea}
          setIsSheetChartAndAreaToHide={props.setIsSheetChartAndAreaToHide}
          isSheetChartAndAreaToHide={props.isSheetChartAndAreaToHide}
        />
      </div>

      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        <ChoiceGroup
          selectedKey={selectedAreaOption}
          disabled={
            objectSource.sheet == null ||
            !isFileExcelExisting ||
            isComponentInstance ||
            isLocked ||
            (props.isEdit && objectSource.sheet?.code === objectSource.sheet?.desc && hasSheetToBeSelected)
          }
          styles={{
            flexContainer: { display: "flex", justifyContent: "left", columnGap: "0.5rem", flexWrap: "wrap" },
          }}
          options={areaOptions}
          onChange={changeAreaSelection}
        />
      </div>

      <ImportAmountAreaSelectionField
        isEdit={props.isEdit}
        area={isNullOrEmptyString(objectSource.cell) ? objectSource.area : objectSource.cell}
        sheet={objectSource.sheet}
        sheetsAreaChartMap={sheetsAreaChartMap}
        selectAreaComboBox={selectAreaComboBox}
        selectCellValue={selectAmountFromExcelCell}
        selectFromAreaName={selectedAreaOption === InputAreaSelectionEnum.AREA_NAME.description}
        isFileExcelExisting={isFileExcelExisting}
        isComponentInstance={isComponentInstance}
        isLocked={isLocked}
        objectSource={objectSource.objectSource}
        isOldValueForAreaToHide={isOldValueForAreaToHide}
        hasSheetToBeSelected={hasSheetToBeSelected}
        isLoadingDataExcel={isLoadingDataExcel}
        setIsOldSheetOrAreaSelected={props.setIsOldSheetOrAreaSelected}
      />
    </div>
  );
};
